export default __webpack_public_path__ + "static/media/cover.f4a2d60e.jpg";